import { Link } from 'react-router-dom';
import { selectTheme } from 'styles/theme/slice/selectors';
import { useSelector } from 'react-redux';

export const LinkWrapper = ({
  children,
  toPath,
  disableNewTab,
  disableThemeFont,
  LinkWrapperStyles,
}) => {
  // const customTheme = useSelector(selectTheme);

  return (
    <Link
      to={toPath}
      {...(!disableNewTab && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
      // style={{ color: !disableThemeFont && customTheme.text }}
      style={{ color: '#fafafa', ...LinkWrapperStyles }}
    >
      {children}
    </Link>
  );
};
